import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-registar-as-render',
  templateUrl: './registar-as-render.component.html',
  styleUrls: [],
})
export class RegistarAsRenderComponent implements ICellRendererAngularComp {
  value: string;
  params: any;

  agInit(params: any): void {
    this.setStatus(params);
  }

  setStatus(params) {
    const list = params.values;
    const value = params.value;

    const found = list.find((element) => {
      if (typeof value === 'object' && value !== null) {
        return (
          element.id === value.id ||
          JSON.stringify(element) === JSON.stringify(value)
        );
      } else {
        return element.id === value || element.pk === value;
      }
    });

    if (found) {
      this.value = found.name;
    }
  }

  refresh(params: any): boolean {
    this.setStatus(params);
    return true;
  }
}
